import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const Page = defineMessages({
  title: {
    id: 'app.auth.forgotPassword.Page.title',
  },
  hint: {
    id: 'app.auth.forgotPassword.Page.hint',
  },
  backToLogin: {
    id: 'app.auth.forgotPassword.Page.backToLogin',
  },
  resetPasswordError: {
    id: 'app.notifications.password.reset.error',
  },
});

export const Form = defineMessages({
  email: {
    id: 'app.auth.forgotPassword.Form.email',
  },
  send: {
    id: 'app.auth.forgotPassword.Form.send',
  },
});
